import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const Check: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M20.71 6.29a1 1 0 0 1 0 1.42l-10 10a1 1 0 0 1-1.42 0l-5-5a1 1 0 0 1 0-1.42 1 1 0 0 1 1.41 0l4.3 4.3 9.29-9.3a1 1 0 0 1 1.42 0Z" />
  </Icon>
);

export default Check;
